import React from "react";
import { Drawer, Grid, makeStyles } from "@material-ui/core";
import { ChatIframe } from "../../../../";
var useStyles = makeStyles(function (theme) {
  return {
    drawerContainer: {
      padding: "24px",
      width: "380px",
      height: "100%"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    title: {
      margin: "16px 0 8px 0"
    },
    card: {
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent"
    },
    cardText: {
      marginTop: "8px"
    },
    cardIconText: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px"
    },
    mr30: {
      marginRight: "30px"
    },
    icon: {
      margin: "8px"
    },
    mt8: {
      marginTop: "8px"
    },
    divider: {
      margin: "4px 0"
    },
    containerDelete: {
      height: "100vh",
      display: "flex",
      alignItems: "center"
    },
    alignCenter: {
      width: "100%",
      textAlign: "center"
    },
    iconDelete: {
      fontSize: "128px",
      textAlign: "center",
      width: "100%"
    },
    iconStaff: {
      fontSize: "80px",
      textAlign: "center",
      width: "100%"
    },
    iconActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificate: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificateLink: {
      textDecoration: "none",
      color: "inherit"
    },
    text: {
      fontFamily: theme.typography.fontFamily
    }
  };
});

var StaffDrawerChat = function StaffDrawerChat(props) {
  console.log("StaffDrawerChat", props);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: props.open,
    onClose: props.toggleDrawer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.drawerContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ChatIframe, {
    room: props.room,
    type: "direct",
    channelName: props.name || "" //   mode={mode}
    ,
    auth_token: props.auth_token,
    chatServer: props.chatServer
  }))));
};

export { StaffDrawerChat };